import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useBudgetProgramSearchDispatch, useBudgetProgramSearchState } from './budget-program-search-context';
import BudgetUnitAppService from '../../../../application/platform/sge/budget-unit/budget-unit-app-service';

export const useBudgetProgramSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useBudgetProgramSearchDispatch();
    const state = useBudgetProgramSearchState();

    useEffect(() => {
        BudgetUnitAppService.list().then((data) =>
            dispatch({ type: ACTION_TYPES.setBudgetUnits, payload: data })
        );
    }, []);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'select-budget-unit') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetUnitId: value || undefined } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetUnitId: undefined, search: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() { navigate('/programas-orcamentarios/cadastrar'); }
    function navigateToEdit(id: number) { navigate(`/programas-orcamentarios/editar/${id}`); }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
